module.exports = __webpack_public_path__ + "assets/img/step9.8947d4c8.png";